import { render, staticRenderFns } from "./StoreLocatorConfigPosts.vue?vue&type=template&id=1db469e4&scoped=true&"
import script from "./StoreLocatorConfigPosts.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorConfigPosts.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorConfigPosts.vue?vue&type=style&index=0&id=1db469e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db469e4",
  null
  
)

export default component.exports